
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; 
import moment from 'moment';

export default {
	
	barChartLabel_: ({ barChartLabel }) => {
		let cols = [];
		for (let i = 0; i < barChartLabel.length ; i++) {
			//let label = '<div style="width:100px; white-space: normal;word-break: break-word;height:auto">' + barChartLabel[i] + '</div>'
			cols.push(barChartLabel[i]);
		}
		return cols;
	},
	
	barDataSet_: ({ barChartData }) => {
		let cols = [];
		let chartData = [];
		for(let i = 0; i < barChartData.length; i++){
			chartData.push(barChartData[i]);
		}
		let newCol = {
			type: 'bar',
			data: chartData,
			backgroundColor: 'rgba(245, 81, 81, 0.43)'
			//borderColor: setChartBdColor(i),
			//borderWidth: 1
		};
		cols.push(newCol);
		return cols;
	},

	stackedLabel_: ({ pieChartLabel }) => {
		let labelArray = [];
		for(let i = 0; i < pieChartLabel.length; i++){
			labelArray.push(pieChartLabel[i]);
		}
		return labelArray;
	},

	stackedDataSet_: ({ pieChartData }) => {


		let data = [];
		for (let i = 0; i < pieChartData.length; i++) {
			data.push(pieChartData[i]);
		}

		let charData = [{
			data: data,
			backgroundColor:  [
				'rgb(255, 99, 132)',
				'rgb(54, 162, 235)',
				'rgb(255, 205, 86)'
			]
			//borderColor: setChartBdColor(i),
			//borderWidth: 1
		}];
		return charData;
	}
};
